import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { VideoModal, videos } from "./VideoModal";

export function Showcase() {
  const baseUrl = import.meta.env.BASE_URL;
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  return (
    <section id="showcase" className="py-0 relative h-screen min-h-[800px] flex items-center group cursor-pointer overflow-hidden">
      <button
        type="button"
        onClick={() => setIsVideoModalOpen(true)}
        aria-label="Watch the reel"
        className="absolute inset-0 z-20 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary"
      />
      <div className="absolute inset-0 z-0">
        <motion.div
          className="w-full h-full"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          <img loading="lazy" decoding="async" 
            src={`${baseUrl}brand/og.jpg`} 
            alt="Cinematic Showcase" 
            className="w-full h-full object-cover object-center opacity-40 group-hover:opacity-60 transition-opacity duration-700"
          />
        </motion.div>
        <div className="absolute inset-0 bg-black/60 group-hover:bg-black/40 transition-colors duration-700" />
      </div>

      <div className="container relative z-10 mx-auto px-6 text-center flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="w-24 h-24 rounded-full border border-primary/50 flex items-center justify-center bg-black/30 backdrop-blur-sm mb-8 group-hover:bg-primary/20 group-hover:border-primary group-hover:scale-110 transition-all duration-500"
        >
          <Play className="w-8 h-8 text-white ml-1" />
        </motion.div>
        
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-display text-5xl md:text-7xl font-bold uppercase tracking-wide"
        >
          Watch the Reel
        </motion.h2>
      </div>

      <VideoModal 
        isOpen={isVideoModalOpen} 
        onClose={() => setIsVideoModalOpen(false)} 
        initialVideoId={videos[0].id}
      />
    </section>
  );
}
